import { render } from "./linkButton.vue?vue&type=template&id=55e99f6a&scoped=true&ts=true"
import script from "./linkButton.vue?vue&type=script&lang=ts"
export * from "./linkButton.vue?vue&type=script&lang=ts"

import "./linkButton.vue?vue&type=style&index=0&id=55e99f6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e99f6a"]])

export default __exports__